import { render, staticRenderFns } from "./report-detail.vue?vue&type=template&id=3db06c08&scoped=true&"
import script from "./report-detail.vue?vue&type=script&lang=js&"
export * from "./report-detail.vue?vue&type=script&lang=js&"
import style0 from "./report-detail.vue?vue&type=style&index=0&id=3db06c08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db06c08",
  null
  
)

export default component.exports